/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
    Grid,
    Row,
    Column,
    Keyboard,
    Button,
    Heading,
    Form,
    FormInput,
    cls,
    ColoredButton,
    TranslationID
} from 'packages/components';
import './_styles.scss';
import { connect } from 'react-redux';
import Assets from '../../requests/apa/Asset';
import Translator from './../../requests/apa/Translator';
import { autobind } from 'packages/core/lib';
import { PASSWORD_REMINDER, REGISTER_INPUT_STYLE_OUTFOCUS } from '../utils/constants';
import AAF from '../../AAF/AAF';
import {
  showModal,
  AAF_MODAL_CHECK_EMAIL,
  AAF_MODAL_SENT_LINK,
  AAF_MODAL_RESEND_EMAIL
} from '../../actions/modal';
import PasswordLogic from './PasswordLogic';
import Device from '../../devices/device';
import { regExp } from 'packages/components/lib/Input/utils';
import Utils from "../../utils/Utils";
import {setMetricsEvent} from "../../actions/metrics";
import {
  LABEL_FORGOT_PASSWORD_CANCEL,
  LABEL_FORGOT_PASSWORD_GET_PASSWORD, LABEL_FORGOT_PASSWORD_OK,
  LABEL_INICIA_SESION,OLVIDASTETUCONTRASENA,OBTENERCONTRASENA,ENTENDIDO, REVISABANDEJA
} from "../utils/constantsMetrics";
import {GA4} from '../../utils/trackers/GA4';

enum Steps {
    STEP_MAIL = 'INSERT_MAIL',
    STEP_PASSWORD = 'INSERT_PASSWORD'
}

interface IProps {
    // sendPasswordReminder: (email: string, routerCallback: () => void) => void;
    passwordReminder: { [key: string]: string };
}

interface IStepsValue {
    [key: string]: string | undefined;
    title: string;
    subtitle: string;
    placeholder: string;
    next?: string;
    cancel?: string;
}

interface ILoginState {
    step: string;
    email: string;
    errorFromBackend: string;
    valid: boolean;
    isSubmit: boolean;
    focusWhenMount: boolean;
    device: string;
}

class PasswordReminder extends Component<RouteComponentProps & IProps, ILoginState> {
    public headerLogo: string = Assets.get('logo_clarotv') || '';
    private passwordLogic: PasswordLogic;
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    private isValidForm: boolean;
    private translations: Record<TranslationID, string>;
    private content: string;

    constructor(props: RouteComponentProps & IProps) {
        super(props);
        this.state = {
            step: Steps.STEP_MAIL,
            email: '',
            errorFromBackend: '',
            valid: true,
            isSubmit: false,
            focusWhenMount: true,
            device: Device.getDevice().getPlatform()
        };
        this.passwordLogic = new PasswordLogic();
        this.isValidForm = false;
        this.content = '';

        this.translations = {
            'password_tooltip_completeField': Translator.get('password_tooltip_completeField_label_validation','Debes completar este campo'),
            'email_tooltip_valid': Translator.get('email_tooltip_valid_label_validation','Ingresa un correo electrónico válido.'),
            'registerMail_tooltip_error': Translator.get('registerMail_tooltip_error_label','Este correo ya está vinculado a la base de datos de Claro video.'),
            'register_forgotten_password': Translator.get('passwordRecovery_access_sendLink_label', 'Te enviaremos un correo con el link para que inicies sesión')
          };
    }

    public componentDidMount() {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener('keydown', this.handleKeyPress, true);
        document && document.addEventListener('keydown', this.onFocus, true);
        Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');

        let email = (this.props
            && this.props.location
            && this.props.location.state
            && this.props.location.state.email);
        if(email) {
            this.isValidForm = true;
            this.setState({email});
        }
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.removeEventListener('keydown', this.handleKeyPress, true);
        document && document.removeEventListener('keydown', this.onFocus, true);
    }

    private handleSubmmit = (): void => {
        const attempts = AAF.Auth.password.getAttempts();
        if (attempts.num >= 5) {
            // TO CHANGE CALLBACK
            const modal = {
                modalType: AAF_MODAL_SENT_LINK,
                modalProps: {
                    callback: () => {
                        this.props.history.push('/landing');
                    },
                    onClose: () => this.props.history.push('/landing'),
                    content: Translator.get(
                        'reminder_sended',
                        'La información solicitada fue enviada a tu cuenta de correo electrónico'
                    )
                }
            };
            this.props.showModal(modal);
        }
        else {
            const { email } = this.state;
            AAF.Auth.password.sendReminder(email).then(
                (response) => {
                    if (response.success) {
                        const modal = {
                            modalType: AAF_MODAL_CHECK_EMAIL,
                            modalProps: {
                                callback: () => {
                                    this.sendMetrics(ENTENDIDO, REVISABANDEJA);
                                    this.props.history.push('/landing')
                                },
                                onClose: () => {
                                    Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
                                },
                                email,
                                content: Translator.get(
                                    'reminder_sended',
                                    'La información solicitada fue enviada a tu cuenta de correo electrónico'
                                )
                            }
                        };
                        this.passwordLogic.onReminderSuccess();
                        this.props.showModal(modal);
                    }
                    else {
                        if(response.response.code === 'USR_USR_00046') {
                          const modal = {
                            modalType: AAF_MODAL_RESEND_EMAIL,
                            modalProps: {
                              callback: () => this.props.history.push('/password-reminder', {email}),
                              email,
                              content: Translator.get(
                                'resendLink_modal_title_label',
                                'Está en camino un link para ti'
                              )
                            }
                          };
                          this.passwordLogic.onReminderSuccess();
                          this.props.showModal(modal);
                        }
                        
                        if (response.response && response.response.code && response.response.code === 'error_404_not_found') {
                            this.content = Translator.get("error_404_not_found", "Servicio no disponible, intentar más tarde");
                            const replace: any = { '{@EMAIL}': email };
                            const codeError = response.response.code;
                            this.content = Translator.get(codeError);
                            if (replace) {
                                for (let i in replace) {
                                    this.content = this.content.replace(i, replace[i]);
                                }
                            }
                        }

                        if(response.response && response.response.code && response.response.code === 'USR_USR_00013'){
                             this.content =  Translator.get("USR_USR_00013");
                        }
                        this.setState({ valid: false, isSubmit: false, errorFromBackend: this.content});
                        this.passwordLogic.onReminderError(response.error);
                    }
                }).catch((err) => {
                    this.passwordLogic.onReminderError(err);
                });
        }
    };

    public sendMetrics(interaction_type: string, moduleName:string){
        const gA4 = new GA4();
        const dataMetrics = Utils.getDataRecoverPassword(this.props.history, interaction_type, moduleName);
        gA4.sendMetricsRecoverPassword(dataMetrics);
    }

    @autobind
    private handleEmailChange(value: string): void {
        let { valid } = this.state;
        this.isValidForm = value !== '';
        if (value === '' || regExp.validEmail.test(value) || regExp.hasNumberMobile.test(value)) {
            valid = true;
        }
        this.setState({ email: value, valid, errorFromBackend: '' });
    }

    public sendMetrics(interaction_type: string, moduleName:string){
        const gA4 = new GA4();
        const dataMetrics = Utils.getDataRecoverPassword(this.props.history, interaction_type, moduleName);
        gA4.sendMetricsRecoverPassword(dataMetrics);
    }

    private handleCancel = (): void => {
        const { step } = this.state;
        switch (step) {
            case Steps.STEP_MAIL:
              Utils.sendMetric(this.props.setMetricsEvent, LABEL_INICIA_SESION, LABEL_FORGOT_PASSWORD_CANCEL, LABEL_INICIA_SESION);
                this.handleLanding();
                break;
            default:
                break;
        }
    };

    private handleLanding = (): void => {
        const { history } = this.props;
        history.push('/landing');
    };

    private validInputText = (valueInput: string): boolean => {
        return regExp.validEmail.test(valueInput);
    };

    private handleNextStep = (): void => {
        this.sendMetrics(OBTENERCONTRASENA, OLVIDASTETUCONTRASENA);
        const { step, email } = this.state;
        let valid = false;
        if (email === '') {
            this.setState({ valid: false, isSubmit: true, errorFromBackend: this.translations['password_tooltip_completeField']});
          } else
          if (!this.validInputText(email)) {
            this.setState({ valid: false, isSubmit: true, errorFromBackend: this.translations['email_tooltip_valid']});
          } else {
            this.setState({ valid: true, isSubmit: true, errorFromBackend: this.translations['email_tooltip_valid']});
          }

        Utils.sendMetric(this.props.setMetricsEvent, LABEL_INICIA_SESION, LABEL_FORGOT_PASSWORD_GET_PASSWORD, LABEL_INICIA_SESION);

        switch (step) {
            case Steps.STEP_MAIL:
                if (regExp.validEmail.test(email)) {
                    this.isValidForm = true;
                    valid = true;
                    Utils.sendMetric(this.props.setMetricsEvent, LABEL_INICIA_SESION, LABEL_FORGOT_PASSWORD_OK, LABEL_INICIA_SESION);
                    this.handleSubmmit();
                }
                this.setState({ valid });
                break;
            default:
                break;
        }
    };

    private getTextBySteps = (attribute: string): string => {
        const result: IStepsValue = {
            title: Translator.get(
                'passwordRecovery_access_title_label',
                '¿Olvidaste tu contraseña?'
            ),
            subtitle: Translator.get(
                'passwordRecovery_access_description_label',
                'Ingresa tu correo electrónico'
            ),
            placeholder: '',
            next: Translator.get(
                'passwordRecovery_access_option_button_next',
                'SIGUIENTE'
            ),
            cancel: Translator.get(
                'passwordRecovery_access_option_button_cancel',
                'CANCELAR'
            )
        };
        return result[attribute] ?? '';
    };


    @autobind
    private handleBack(): void {
        const { history } = this.props;
        history.push('/login', { InsertPassword: Steps.STEP_PASSWORD, email: this.state.email });
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case "YELLOW":
              if(Utils.isModalHide())
                this.handleBack();
                break;
        }
    }

    @autobind
    private handleKeyPress(e: any): void {
        const { step } = this.state;
        const { history } = this.props;
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'BACK') {
            if(step == Steps.STEP_MAIL) {
                history.push('/login', { InsertPassword: Steps.STEP_PASSWORD, email: this.state.email });
            } else {
                this.isValidForm = true;
                Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
                this.setState({ step: Steps.STEP_MAIL, valid:true, errorFromBackend: ''});
            }
        }
    }

    @autobind
    private onFocus (): void  {
        Utils.onFocusElement([{ id: 'emailInput'}]);
    }

    public render(): JSX.Element {
        const { step, valid, isSubmit, errorFromBackend, focusWhenMount } = this.state;

        return (
            <Grid>
                <Row className={cls(`${PASSWORD_REMINDER}-row`)}>
                    <Column lg={3} className={cls(`${PASSWORD_REMINDER}-header-logo`)}>
                        <img src={this.headerLogo} alt="claroTv logo" />
                    </Column>
                    <Column offset={7} lg={2} className={cls(`${PASSWORD_REMINDER}-header-buttons`)}>
                        <ColoredButton
                            onClick={this.handleBack}
                            children = {Translator.get('top_head_option_button_back','REGRESAR')}
                            color="yellow"
                            imgSrc = {Assets.get('top_head_option_back', '')}
                            onFocus = {this.onFocus}
                        />
                    </Column>
                </Row>
                <Row>
                    <Form id="password-reminder-form">
                        <Column lg={6} className={cls(`${PASSWORD_REMINDER}-column-keyboard`)}>
                            <Keyboard onFocus = {this.onFocus}/>
                        </Column>
                        <Column lg={6} className={cls(`${PASSWORD_REMINDER}-column-inputs`)}>
                            <Row className={cls(`${PASSWORD_REMINDER}-row-inputs`)}>
                                {/* ************** TITLE ****************** */}
                                <Column lg={12}>
                                    <Heading size={1} className={cls(`${PASSWORD_REMINDER}-title`)}>
                                        {this.getTextBySteps('title')}
                                    </Heading>
                                </Column>

                                {/* ************** SUBTITLE ****************** */}
                                <Column lg={12}>
                                    <Heading
                                        size={2}
                                        className={cls(`${PASSWORD_REMINDER}-subtitle`)}
                                    >
                                        {this.getTextBySteps('subtitle')}
                                    </Heading>
                                </Column>
                                {/* ************** INPUT AND  BUTON PASSWORD, EMAIL ****************** */}
                                <Row className={cls(`${PASSWORD_REMINDER}-column-input`)}>
                                    {step === Steps.STEP_MAIL && (
                                        <Column lg={12}>
                                            <FormInput
                                                id = 'emailInput'
                                                focusWhenMount = {focusWhenMount}
                                                type="email"
                                                name="email"
                                                value={ this.state.email ? this.state.email : null}
                                                onChange={this.handleEmailChange}
                                                placeholder={this.getTextBySteps('placeholder')}
                                                validInput={valid}
                                                translations={this.translations}
                                                errorFromBackend={errorFromBackend}
                                                submit = {isSubmit}
                                            />
                                        </Column>
                                    )}
                                </Row>
                                {/* ************** email legend ************** */}
                                <Column lg={12} className={cls(`${PASSWORD_REMINDER}-email-rule`)}>
                                    <p className={cls(`${PASSWORD_REMINDER}-rule-email`)}>
                                      {this.translations['register_forgotten_password']}
                                    </p>
                                </Column>
                                {/* ************** CANCEL BUTTON AND CONFIRM BUTTON ****************** */}
                                <Column lg={11}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        className={cls(`focusable`, `${PASSWORD_REMINDER}-button-next`, this.isValidForm ? '' : 'disabled')}
                                        onClick={this.handleNextStep}
                                        block
                                        onFocus = {this.onFocus}
                                    >
                                        {this.getTextBySteps('next')}
                                    </Button>
                                </Column>
                                <Column lg={11} className={cls(`${PASSWORD_REMINDER}-column-next`)}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="default"
                                        className={cls(`focusable`, `${PASSWORD_REMINDER}-button-cancel`)}
                                        onClick={this.handleCancel}
                                        block
                                        onFocus = {this.onFocus}
                                    >
                                        {this.getTextBySteps('cancel')}
                                    </Button>
                                </Column>
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal,
    setMetricsEvent
};

export default connect(null, mapDispatchToProps)(PasswordReminder);



// WEBPACK FOOTER //
// ./src/authentication/PasswordReminder/index.tsx